<template>
  <div>
    <div v-if="isManager" class="row no-gutters">
    <div class="col-12 col-md-6 col-lg-7">
      <div class="left-panel d-flex flex-column">
        <div class="left-panel-header px-3 pt-3 flex-none border-bottom">
          <div class="d-flex justify-content-between">
            <h3 class="">Add Locations</h3>
          </div>
        </div>
        <div
          v-if="!isBulkUploading"
          class="row no-gutters mt-1 d-none d-lg-flex flex-none border-bottom font-weight-bold"
        >
          <div class="col-6 pl-4">Name</div>
          <div class="col-3 pl-2">Latitude</div>
          <div class="col-3 pl-2">Longitude</div>
        </div>
        <div
          class="location-list flex-grow-1 overflow-auto"
          v-if="!isBulkUploading"
        >
          <div
            class="row no-gutters mb-1 border-bottom justify-content-between py-lg-1 px-lg-0 p-2"
            v-for="location in locations"
            :key="location.key"
          >
            <div class="d-none d-lg-block col-lg-auto px-1 align-self-center">
              {{ location.key }}
            </div>
            <div class="col-12 col-lg pb-2 pb-lg-0">
              <label
                :for="`location_${location.key}_name`"
                class="d-block d-lg-none">
                <span class="font-weight-bold">{{ location.key }}.</span>
                Name
              </label>
              <b-form-input
                :id="`location_${location.key}_name`"
                :ref="`location_${location.key}_name`"
                type="text"
                :name="`location_${location.key}_name`"
                :placeholder="`Location name ${location.key}`"
                v-model.trim="location.name"
                v-validate="{ required: true, min: 5, max: 100 }"
                :data-vv-as="`Location ${location.key} name`"
                data-vv-delay="500"
                :class="{
                  'is-invalid': errors.has(`location_${location.key}_name`),
                }"
                :aria-describedby="`location_${location.key}_name-live-feedback`"
              >
              </b-form-input>
            </div>
            <div class="col-6 col-lg-3 pb-2 pb-lg-0">
              <label
                :for="`location_${location.key}_latitude`"
                class="d-block d-lg-none">
                Latitude
              </label>
              <b-form-input
                :id="`location_${location.key}_latitude`"
                :ref="`location_${location.key}_latitude`"
                type="number"
                :number="true"
                :name="`location_${location.key}_latitude`"
                placeholder="±90.0000000"
                :step="0.0005"
                v-model="location.lngLat.lat"
                v-validate="{
                  required: true,
                  decimal: 7,
                  min_value: -90,
                  max_value: 90,
                }"
                :data-vv-as="`Location ${location.key} latitude`"
                data-vv-delay="500"
                :class="{
                  'is-invalid': errors.has(`location_${location.key}_latitude`),
                }"
                :aria-describedby="`location_${location.key}_latitude-live-feedback`"
              >
              </b-form-input>
            </div>
            <div class="col-6 col-lg-3 pb-2 pb-lg-0">
              <label
                :for="`location_${location.key}_longitude`"
                class="d-block d-lg-none">
                Longitude
              </label>
              <b-form-input
                :id="`location_${location.key}_longitude`"
                :ref="`location_${location.key}_longitude`"
                type="number"
                :number="true"
                :name="`location_${location.key}_longitude`"
                placeholder="±180.0000000"
                :step="0.0005"
                v-model="location.lngLat.lng"
                v-validate="{
                  required: true,
                  decimal: 7,
                  min_value: -180,
                  max_value: 180,
                }"
                :data-vv-as="`Location ${location.key} longitude`"
                data-vv-delay="500"
                :class="{
                  'is-invalid': errors.has(`location_${location.key}_longitude`),
                }"
                :aria-describedby="`location_${location.key}_longitude-live-feedback`"
              >
              </b-form-input>
            </div>
            <div class="col-2 col-lg-auto pl-lg-1 pr-lg-1 d-flex h-100 align-self-end">
              <div class="btn-group">
                <div
                  v-if="!location.isSaving"
                  class="btn btn-danger"
                  @click="deleteLocationClick(location.key)"
                  title="Delete Location"
                >
                  <i class="fa fa-trash"></i>
                </div>
                <div v-if="location.isSaving">
                  <i class="fa fa-spinner fa-spin"></i>
                </div>
              </div>
            </div>
            <div class="col-10 col-lg-12 pl-3 pr-1">
              <b-form-invalid-feedback
                :id="`location_${location.key}_name-live-feedback`"
                class="d-inline"
                :state="true"
                >{{
                  errors.first(`location_${location.key}_name`)
                }}</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                :id="`location_${location.key}_latitude-live-feedback`"
                class="d-inline"
                :state="true"
                >{{
                  errors.first(`location_${location.key}_latitude`)
                }}</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                :id="`location_${location.key}_longitude-live-feedback`"
                class="d-inline"
                :state="true"
                >{{
                  errors.first(`location_${location.key}_longitude`)
                }}</b-form-invalid-feedback
              >
            </div>
          </div>
        </div>
        <div class="d-flex flex-none justify-content-between p-3 border-top"
             v-if="!isBulkUploading">
          <div class="flex-none btn-group mr-2">
            <div class="btn btn-primary flex-none" @click="addClicked">
              <i class="fa fa-plus mr-2"></i>Add
            </div>
            <div class="btn btn-secondary" @click="isBulkUploading = true">
              <i class="fa fa-upload mr-2"></i>Bulk Upload
            </div>
          </div>
          <div class="flex-none btn-group">
            <b-link
              :to="{
                name: 'ProjectLocations',
                params: { id: $route.params.id },
              }"
              class="btn btn-secondary"
            >
              <i class="fa fa-close mr-2"></i>Cancel
            </b-link>
            <div class="btn btn-success" @click="saveClicked">
              <i class="fa fa-save mr-2"></i>Save All
            </div>
          </div>
        </div>

        <Bulk
          v-if="isBulkUploading"
          @close="isBulkUploading = false"
          @addLocations="addLocations"
          :lastLocationKey="lastLocationKey"
        ></Bulk>
      </div>
    </div>
    <div class="right-panel col-12 col-md-6 col-lg-5">
      <LMap
        :zoom="map.zoom"
        :center="map.center"
        class="location-map"
        @click="mapClick"
        ref="leaflet"
        :options="map.options"
        @ready="addBasemapLayer(BASEMAP_ACTIVE)"
      >
        <LLayerGroup>
          <LMarker
            v-for="location in locations"
            v-if="
              location.lngLat.lng &&
              !isNaN(location.lngLat.lng) &&
              location.lngLat.lat &&
              !isNaN(location.lngLat.lat)
            "
            :key="location.key"
            :latLng="location.lngLat"
            @moveend="
              (e) =>
                dragend({
                  key: location.key,
                  newLatLng: e.sourceTarget._latlng,
                })
            "
            :draggable="true"
          >
            <MarkerPin>{{ location.key }}</MarkerPin>
            <LTooltip>
              <div>Drag to move</div>
              <div>'{{ location.name }}'</div>
            </LTooltip>
          </LMarker>

          <LMarker v-if="projectHome" key="home" :latLng="projectHome">
            <MarkerPin><i class="fa fa-home"></i></MarkerPin>
            <LTooltip> Project home </LTooltip>
          </LMarker>
          <LRectangle
            v-if="searchArea.area && searchArea.area.bounds"
            :bounds="searchArea.area.bounds"
            :l-style="searchArea.style"
          >
          </LRectangle>
          <LCircle
            v-else-if="
              searchArea.area &&
              searchArea.area.lngLat &&
              searchArea.area.accuracy
            "
            :lat-lng="searchArea.area.lngLat"
            :radius="searchArea.area.accuracy"
            :l-style="searchArea.style"
          >
          </LCircle>
        </LLayerGroup>
        <LControlZoom position="bottomright"></LControlZoom>
      </LMap>
      <GpsGeocoderInput
        v-on:input="setMapView"
        ref="GpsGeocoderInput"
        class="position-absolute map-search"
      />
      <div class="position-absolute map-help text-center" v-if="!isMapClicked">
        <div>Click / tap to add marker</div>
        <div>Drag existing markers</div>
      </div>
    </div>
  </div>
    <RequiresManager v-else page="Add Locations"></RequiresManager>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RequiresManager from "../tabpermission/requiresManager.vue";
import Bulk from "./bulk.vue";

import {
  LMap,
  LTileLayer,
  LMarker,
  LLayerGroup,
  LPolyline,
  LPopup,
  LTooltip,
  LRectangle,
  LCircle,
  LControlZoom,
} from "vue2-leaflet";

import MarkerCrosshairs from "../../../../components/common/map/MarkerCrosshairs.vue";
import MarkerPin from "../../../../components/common/map/MarkerPin.vue";
import GpsGeocoderInput from "../../../common/map/gpsGeocoderInput.vue";

export default {
  name: "AddLocations",
  components: {
    RequiresManager,
    Bulk,
    LMap,
    LTileLayer,
    LMarker,
    LLayerGroup,
    LPolyline,
    MarkerCrosshairs,
    MarkerPin,
    LPopup,
    LTooltip,
    LRectangle,
    LCircle,
    LControlZoom,
    GpsGeocoderInput,
  },
  data() {
    return {
      locations: [],
      lastLocationKey: 0,
      map: {
        zoom: 5,
        center: { lng: -110.0, lat: 45.0 },
        options: {
          zoomControl: false,
        },
      },
      searchArea: {
        area: null,
        style: {
          color: "#000000",
          weight: 10,
          opacity: 0.8,
          fillOpacity: 0,
        },
        tooltipStyle: {
          permanent: true,
          direction: "top",
          offset: [0, 100],
        },
      },
      isMapClicked: false,
      isBulkUploading: false,
    };
  },
  mounted() {
    if (this.project && this.project.latitude && this.project.longitude) {
      this.map.center = {
        lng: this.project.longitude,
        lat: this.project.latitude,
      };
    }
  },
  computed: {
    ...mapGetters({
      project: "project/get/project",
      isManager: "project/get/isManager",
      BASEMAP_ACTIVE: "map/BASEMAP_ACTIVE",
    }),
    projectHome() {
      if (this.project && this.project.latitude && this.project.longitude) {
        return {
          lng: this.project.longitude,
          lat: this.project.latitude,
        };
      }
      return;
    },
  },
  methods: {
    ...mapActions({
      createLocation: "project/locations/createLocation",
      updateLocation: "project/locations/updateLocation",
      deleteLocation: "project/locations/deleteLocation",
      getProjectStats: "project/get/stats/get",
      setLocationSortBy: "project/get/setLocationTableSortBy",
      setLocationTableSortDesc: "project/get/setLocationTableSortDesc",
      setLocationTablePage: "project/get/setLocationTablePage",
    }),
    addClicked() {
      if (this.isBulkUploading) {
        // if bulk uploading, switch back
        this.isBulkUploading = false;
        return;
      }
      this.newLocation();
      this.$nextTick(() => {
        let focusRef = this.$refs[`location_${this.lastLocationKey}_name`];
        focusRef[0].$refs.input.focus();
      });
    },
    mapClick(e) {
      this.isMapClicked = true;
      if (this.isBulkUploading) {
        this.isBulkUploading = false;
        return;
      }
      const lastLocation = this.locations[this.locations.length - 1];
      if (
        this.locations.length === 0 ||
        (lastLocation.name &&
          lastLocation.lngLat.lat &&
          lastLocation.lngLat.lng)
      ) {
        // if there are no locations, add it. If the last location has a name & lat lon, add a new one
        this.newLocation();
      }
      this.locations[this.locations.length - 1].lngLat = {
        lng: e.latlng.lng.toFixed(7),
        lat: e.latlng.lat.toFixed(7),
      };
      this.$nextTick(() => {
        let focusRef = this.$refs[`location_${this.lastLocationKey}_name`];
        focusRef[0].$refs.input.focus();
      });
    },
    newLocation() {
      this.locations.push({
        name: null,
        lngLat: {
          lng: null,
          lat: null,
        },
        key: ++this.lastLocationKey,
        isSaving: false,
        "@id": null,
        error: null,
      });
    },
    dragend(event) {
      const locationIndex = this.locations.findIndex(
        (l) => l.key === event.key
      );
      this.locations[locationIndex].lngLat = {
        lng: event.newLatLng.lng.toFixed(7),
        lat: event.newLatLng.lat.toFixed(7),
      };
    },
    deleteLocationClick(key) {
      const locationIndex = this.locations.findIndex((l) => l.key === key);
      const locationToDelete = this.locations[locationIndex];
      if (locationToDelete["@id"]) {
        this.deleteLocation(locationToDelete["@id"]);
      }
      this.locations.splice(locationIndex, 1);
    },
    addLocations(newLocations) {
      this.isBulkUploading = false;
      const firstLocationKey = newLocations[0].key;
      this.lastLocationKey = newLocations[newLocations.length - 1].key;
      this.locations = [...this.locations, ...newLocations];

      this.$nextTick(() => {
        this.$validator.validate();
        // focus text box and fit map to all locations
        let focusRef = this.$refs[`location_${firstLocationKey}_name`];
        focusRef[0].$refs.input.focus();
        const locationBounds = this.locations
          .filter((location) => {
            return (
              location.lngLat.lng &&
              !isNaN(location.lngLat.lng) &&
              location.lngLat.lat &&
              !isNaN(location.lngLat.lat)
            );
          })
          .map((location) => {
            return location.lngLat;
          });
        if (locationBounds.length > 1) {
          this.$refs.leaflet.mapObject.flyToBounds(locationBounds);
        } else {
          this.$refs.leaflet.mapObject.flyTo(locationBounds[0]);
        }
      });
    },
    saveClicked() {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          // Focus on earliest error
          let focusRef = this.$refs[this.errors.items[0].field];
          focusRef[0].$refs.input.focus();
          return;
        }
        this.saveLocations();
      });
    },
    saveLocations() {
      let promises = [];
      this.locations.forEach((location) => {
        // Adding project IRI to link the location to this project
        location.isSaving = true;
        if (location["@id"]) {
          this.updateLocation(location)
            .then((response) => {
              if (response.status === 200) {
                return response.json();
              }
            })
            .then((body) => {
              const locationIndex = this.locations.findIndex(
                (l) => l.key === location.key
              );
              const newLocation = {
                ...body,
                key: location.key,
                isSaving: false,
              };
              this.locations.splice(locationIndex, 1, newLocation);
            });
          return;
        }
        let promise = this.createLocation(location)
          .then((response) => {
            if (response.status === 201) {
              return response.json();
            }
          })
          .then((body) => {
            const locationIndex = this.locations.findIndex(
              (l) => l.key === location.key
            );
            const newLocation = {
              ...body,
              key: location.key,
              isSaving: false,
            };
            this.locations.splice(locationIndex, 1, newLocation);
          });
        promises.push(promise);
      });

      // wait till all request are complete <shows loading screen only one time>
      Promise.all(promises).then((values) => {
        // Call parent to update stats
        this.getProjectStats();
        this.setLocationSortBy("createdAt");
        this.setLocationTableSortDesc(true);
        this.setLocationTablePage(1);
        this.$router.push({
          name: "ProjectLocations",
          params: { id: this.$route.params.id },
        });
      });
    },
    setMapView(searchArea) {
      console.log("setMapView", searchArea);
      this.searchArea.area = searchArea;
      if (searchArea && searchArea.bounds) {
        this.$refs.leaflet.mapObject.flyToBounds(searchArea.bounds);
      } else if (searchArea && searchArea.lngLat) {
        this.$refs.leaflet.mapObject.flyTo(searchArea.lngLat, searchArea.zoom);
      }
    },
    addBasemapLayer(newLayer, oldLayer) {
      const map = this.$refs.leaflet && this.$refs.leaflet.mapObject;
      if (!map || !newLayer) return;
      if (oldLayer) {
        try {
          map.removeLayer(oldLayer);
        } catch (e) {}
      }
      newLayer.addTo(map);
      map.invalidateSize();
    },
  },
  watch: {
    BASEMAP_ACTIVE(newLayer, oldLayer) {
      this.addBasemapLayer(newLayer, oldLayer);
    },
  },
};
</script>
<style scoped>
.location-map {
  height: 50vh;
  min-height: 300px;
}
.left-panel {
  max-height: 50vh;
}
.map-help {
  z-index: 999;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 10px;
}
.map-search {
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 500;

  @media (min-width: 768px) {
    width: 50%;
  }
}
</style>
